module.exports = __webpack_public_path__ + "img/bigwin-text.d99c3682.png";